import React from 'react';
import { Modal, Typography } from 'antd';
import { t } from '../../../shared/i18n';
import cdnService from '../../services/cdnService';

// 托管 DNS 里已有这些名字的解析:加入 CDN 后会改成走 CDN,先让用户确认。返回 true = 继续
export default async function confirmDnsTakeover(hostnames) {
    const records = await cdnService.getDnsConflicts(hostnames);
    if (!records.length) return true;
    return new Promise((resolve) => Modal.confirm({
        title: t('These names already have DNS records'),
        content: (
            <div>
                {records.map((r, i) => (
                    <div key={i}><Typography.Text code>{`${r.hostname}  ${r.type}  ${r.content}`}</Typography.Text></div>
                ))}
                <div style={{ marginTop: 8 }}>{t('After adding, they will be served through CDN.')}</div>
            </div>
        ),
        okText: t('Continue'),
        cancelText: t('Cancel'),
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
    }));
}
